import React from 'react';
import {
    View, Text, Image, StyleSheet, Page//, Font
} from '@react-pdf/renderer';
import { isFunction } from '../../Helpers/Calculations';
import line from './point.png';
import { formatDate } from '../../Helpers/Formatters';

const styles = StyleSheet.create(
    {
        tab: { marginTop: 30, marginLeft: 10, marginRight: 10, width: "100%" },
        pageview: { margin: 24, marginRight: 40, marginLeft: 40 },

        title: { fontSize: 12, borderBottom: '1 solid #747679', width: '95%', fontFamily: "RobotoRegular", color: '#373534' },
        line: { width: "100%", height: "1px" },
        disclaimer: { fontFamily: "RobotoItalic", fontSize: 10, marginTop: 10, marginBottom: 10 },
        declaration: { fontFamily: "RobotoRegular", fontSize: 9, marginTop: 10 },
        paragraph: { marginTop: 5 },

        row: { marginTop: 2, marginLeft: 30, fontSize: 10, fontFamily: "RobotoRegular", display: "flex", flexDirection: "row" },
        label: { width: "40%", textAlign: "right", marginRight: 10 },
        value: { width: "45%" },

        section: { fontFamily: "RobotoBold", fontSize: 11 },
        signature: { marginTop: 20 }
    }
)

//Simplifying this because we aren't really in a position to "reuse" any of this for now.
//So, for now dataKey === the data name of the field, or a function (ctx) => return ctx.something, that takes
//the form context as the parameter.
const MorphoSysPrescriptionPdf = props => {
    // Font.register({family: 'RobotoRegular', src:'https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxP.ttf'});
    // Font.register({family: 'RobotoBold', src:'https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlvAw.ttf'});
    // Font.register({family: 'RobotoItalic', src:'https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu52xP.ttf'});

    const { form } = props;

    return <Page>
        <View style={styles.pageview}>
            <Text style={styles.title}>Prescription Information</Text>

            <Text style={styles.disclaimer}>
                AssistPoint is not a validated or certified e-Prescribing platform.
                The information contained within is simply a representation of the completed data fields
                which are an exact replication of the information collected on the MyMISSION enrollment form.
            </Text>

            <View style={styles.row}>
                <Text style={styles.section}>Patient</Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>First Name</Text>
                <Text style={styles.value}><TemplateValue dataKey="Patient Name First" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Last Name</Text>
                <Text style={styles.value}><TemplateValue dataKey="Patient Name Last" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Date of Birth</Text>
                <Text style={styles.value}><TemplateValue dataKey="Patient DOB" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Street Address</Text>
                <Text style={styles.value}><TemplateValue dataKey="Patient Address 1" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>City</Text>
                <Text style={styles.value}><TemplateValue dataKey="Patient City" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>State</Text>
                <Text style={styles.value}><TemplateValue dataKey="Patient State" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Zip Code</Text>
                <Text style={styles.value}><TemplateValue dataKey="Patient Zip Code" ctx={form} /></Text>
            </View>


            <View style={styles.row}>
                <Text style={styles.section}>Order</Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Brand Name</Text>
                <Text style={styles.value}><TemplateValue dataKey={ctx => ctx.meta.brandName} ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Patient Weight (kg)</Text>
                <Text style={styles.value}><TemplateValue dataKey="Order Free Drug Patient Weight" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Prescription Dose (mg)</Text>
                <Text style={styles.value}><TemplateValue dataKey="Order Free Drug MorphoSys Dosage" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Prescription Cycle</Text>
                <Text style={styles.value}><TemplateValue dataKey="Order Free Drug MorphoSys Cycle" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Directions</Text>
                <Text style={styles.value}><TemplateValue dataKey="Order Free Drug MorphoSys Directions" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Quantity</Text>
                <Text style={styles.value}><TemplateValue dataKey="Order Free Drug MorphoSys Quantity" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Refills</Text>
                <Text style={styles.value}><TemplateValue dataKey="Order Free Drug MorphoSys Refills" ctx={form} /></Text>
            </View>



            <View style={styles.row}>
                <Text style={styles.section}>Provider</Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>First Name</Text>
                <Text style={styles.value}><TemplateValue dataKey="Provider Physician Name First" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Last Name</Text>
                <Text style={styles.value}><TemplateValue dataKey="Provider Physician Name Last" ctx={form} /></Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.label}>Physician NPI Number</Text>
                <Text style={styles.value}><TemplateValue dataKey="Provider Physician NPI Number" ctx={form} /></Text>
            </View>

            <View style={styles.declaration}>
                <Text style={styles.paragraph}>
                    I certify that the Patient and Prescriber information contained in this enrollment form
                    is complete and accurate to the best of my knowledge. I have prescribed MONJUVI based on my
                    judgment of medical necessity and I will be supervising the patient’s treatment.
                </Text>

                <Text style={styles.paragraph}>
                    I have received the necessary patient authorization prior to the transmittal of health information to MorphoSys US Inc., MorphoSys
                    Foundation, Incyte Corporation or their respective third-party contractors, agents or designees, to initiate patient enrollment into My
                    MISSION Support.
                </Text>

                <Text style={styles.paragraph}>
                    If requested, I authorize the forwarding of the prescription to a dispensing specialty pharmacy on behalf of myself and the Patient. I agree that I will not
                    seek reimbursement for any free product received under the PAP for this Patient or for any other patient. I further agree that the Patient should also
                    not seek reimbursement for any free product received under the PAP. In addition to not seeking reimbursement, I agree to notify My MISSION Support
                    immediately if the Patient is no longer receiving product through the PAP and agree to return unused donated PAP product.
                </Text>

                <Text style={styles.paragraph}>
                    I certify that I will comply with all applicable state specific prescription requirements such as e-prescribing, state specific prescription form, fax language,
                    etc.
                </Text>

                <Text style={styles.paragraph}>I understand that non-compliance with state specific requirements could result in outreach.</Text>
            </View>

            <View style={styles.signature}>
                <View style={styles.row}>
                    <Text style={styles.label}>Prescriber Signature</Text>
                    <TemplateSig dataKey="Signature Prescriber Canvas" ctx={form} />
                </View>

                <View style={styles.row}>
                    <Text style={styles.label}>Prescriber Name</Text>
                    <Text style={styles.value}>
                        <TemplateValue dataKey="Signature Prescriber Name" ctx={form} />
                        {/* <TemplateValue dataKey={ctx => ctx.formData["Provider Physician Name First"] + ' ' + ctx.formData["Provider Physician Name Last"]}  ctx={form}/> */}
                    </Text>
                </View>

                <View style={styles.row}>
                    <Text style={styles.label}>Date</Text>
                    <Text style={styles.value}><TemplateValue dataKey="Signature Prescriber Date" ctx={form} /></Text>
                </View>

                <View style={styles.row}>
                    <Text style={styles.label}>SigKey</Text>
                    <Text style={styles.value}>
                        <TemplateValue dataKey="Signature Prescriber Key" ctx={form} />
                    </Text>
                </View>
            </View>
        </View>
    </Page>
}

const TemplateValue = props => {
    const { dataKey, ctx } = props;

    const value = isFunction(dataKey)
        ? dataKey(ctx)
        : ctx.formData[dataKey];

    const formattedValue = isFunction(dataKey)
        ? value
        : ctx.getFieldDef(dataKey).type === "date"
            ? formatDate(value)
            : value;


    return isNaN(formattedValue)
        ? formattedValue || ""
        : formattedValue;
}

const TemplateSig = props => {
    const { dataKey, ctx } = props;

    let value = isFunction(dataKey)
        ? dataKey(ctx)
        : ctx.formData[dataKey];

    if (value === undefined) return "";

    const src = { uri: value };

    return <View>
        {/* The border style didn't work. How do I make a box around the sig? */}
        <Image src={src} style={{ width: 200, height: 25, border: "1px solid black" }} />
        <Image src={line} style={{ width: 200, height: "1px" }} />
    </View>
}


export default MorphoSysPrescriptionPdf;
